import { Navigate, type RouteObject } from 'react-router';

import TransactionsLayout from '../layouts/TransactionsLayout';
import { TransactionsPage } from '../pages/TransactionsPage';
import { RequireBetaTenant } from '@/components/permissions/RequireBetaTenant';
import RequirePermissionRoute from '@/components/permissions/RequirePermissionRoute';
import { Permission } from '@/modules/users/submodules/roles/api/permissions.contracts';

export const TRANSACTION_ROUTES: RouteObject[] = [
  {
    path: 'transactions',
    element: (
      <RequireBetaTenant>
        <TransactionsLayout />
      </RequireBetaTenant>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="overview" replace />,
      },
      {
        path: 'overview',
        element: (
          <RequirePermissionRoute requiredPermission={Permission.TRANSACTIONS_VIEW}>
            <TransactionsPage />
          </RequirePermissionRoute>
        ),
      },
      {
        path: 'overview/:transactionId',
        element: (
          <RequirePermissionRoute requiredPermission={Permission.TRANSACTIONS_VIEW}>
            <TransactionsPage />
          </RequirePermissionRoute>
        ),
      },
    ],
  },
];
